// extracted by mini-css-extract-plugin
export default {"container":"LogoClock_container__R4JBh","clockFace":"LogoClock_clockFace__mAd0T","hourHand":"LogoClock_hourHand__i2zEJ","minuteHand":"LogoClock_minuteHand__57N3H"};